<template>
    <modal @close="$emit('close')" ref="modal" :is-closeable="isCloseable" :autoshow="true">
        <template v-slot:title>
            <span>Update Asure Codes: </span><span class="text-thin text-nowrap">{{ symTax.description }}</span>
        </template>
        <slot>
            <form class="mui-form" @submit.prevent="onSubmit()">
                <form-errors :errors="formErrors"/>

                <div class="form-row">
                    <div class="col">
                        <form-input v-model="formData.asure_code" :errors="errors.asure_code" type="text" label="Asure Code" />
                    </div>
                </div>

                <div class="form-row">
                    <div class="col">
                        <form-input v-model="formData.asure_code_non_resident" :errors="errors.asure_code_non_resident" type="text" label="Asure Code (Non-Resident)" />
                    </div>
                </div>
            </form>
        </slot>

        <template v-slot:footer>
            <div class="form-row">
                <div class="col">
                    <button type="button" class="btn btn-block btn-outline-primary" @click.prevent="close()">Cancel</button>
                </div>
                <div class="col">
                    <button type="button" class="btn btn-block btn-primary" @click.prevent="onSubmit()">Save</button>
                </div>
            </div>
        </template>
    </modal>
</template>

<script>
import FormMixin from '@/mixins/Form'
import ModalMixin from '@/mixins/ModalMixin'

export default {
    props: ['symTax', ],
    mixins: [FormMixin, ModalMixin, ],
    data() {
        return {
            formData: {
                asure_code: this.symTax.asure_code,
                asure_code_non_resident: this.symTax.asure_code_non_resident,
            },
        }
    },
    methods: {
        getFormData() {
            return {
                asure_code: this.formData.asure_code,
                asure_code_non_resident: this.formData.asure_code_non_resident,
            }
        },
        onSubmit() {
            if (!this.validate()) {
                return
            }

            this.$store.dispatch('START_LOADING')
            return this.$api.put(`/admin/tax-engine/sym-taxes/${this.symTax.id}`, this.getFormData()).then(resp => {
                this.$store.dispatch('STOP_LOADING')
                this.$emit('updated', resp)
                this.close()
            }).catch(errors => {
                this.$store.dispatch('STOP_LOADING')
                this.errors = errors
                this.formErrors = errors.__all__
                this.onError()
            })
        },
    }
}
</script>
